module.exports = __webpack_public_path__ + "img/pocket_length.f4c76625.png";